import React, { useState } from "react";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../helpers/spinner";
import { Link } from "react-router-dom";
const CAMPAIGN_TYPE_STATUS = {
  active: "فعال",
  active_alternative: "فعال جایگزین",
  pending: "در حالت انتظار",
  pending_alternative: "در حالت انتظار جایگزین",
};
function CheckPositionCampaign() {
  const [
    positionsMustHaveThisCampaignButDoNotHave,
    setPositionsMustHaveThisCampaignButDoNotHave,
  ] = useState([]);
  const [
    positionsMustNotHaveThisCampaignButHave,
    setPositionsMustNotHaveThisCampaignButHave,
  ] = useState([]);

  const sendForm = async () => {
    const campaignID = document.querySelector("#campaign-id").value;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const result = await sendRequestCheckCampaignsInPositions(campaignID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!result) {
      return;
    }
    setPositionsMustHaveThisCampaignButDoNotHave(
      result.positions_must_have_this_campaign_but_do_not_have
    );
    setPositionsMustNotHaveThisCampaignButHave(
      result.positions_must_not_have_this_campaign_but_have
    );
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestCheckCampaignsInPositions = async (campaignID) => {
    const headersRequest = getHeaderForRequest();
    let result;
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/manage/check-campaigns-in-positions/" +
          campaignID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return result.data.data;
  };

  const generateStatusTypeCampaign = (campaignStatusType) => {
    return CAMPAIGN_TYPE_STATUS[
      campaignStatusType.replace("campaign_IDS_", "")
    ];
  };

  const generateTablePositionsMustHaveThisCampaignButDoNotHave = () => {
    if (positionsMustHaveThisCampaignButDoNotHave.length === 0) {
      return <p>جایگاه ها مشکلی ندارن</p>;
    }

    return (
      <div className="table-responsive">
        <table className="table table-hilite tbl-td-white-space table-hover">
          <thead>
            <tr>
              <td>#</td>
              <td>تگ html جایگاه</td>
              <td>حالت</td>
            </tr>
          </thead>
          <tbody>
            {positionsMustHaveThisCampaignButDoNotHave.map((item, index) => {
              return (
                <tr>
                  <td>{index + 1}</td>
                  <td>{item.tag_html_id}</td>
                  <td>
                    {generateStatusTypeCampaign(item.campaign_status_type)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  const generateTablePositionsMustNotHaveThisCampaignButHave = () => {
    if (positionsMustNotHaveThisCampaignButHave.length === 0) {
      return <p>جایگاه ها مشکلی ندارن</p>;
    }
    return (
      <div className="table-responsive">
        <table className="table table-hilite tbl-td-white-space table-hover">
          <thead>
            <tr>
              <td>#</td>
              <td>تگ html جایگاه</td>
              <td>حالت</td>
            </tr>
          </thead>
          <tbody>
            {positionsMustNotHaveThisCampaignButHave.map((item, index) => {
              return (
                <tr>
                  <td>{index + 1}</td>
                  <td>{item.tag_html_id}</td>
                  <td>
                    {generateStatusTypeCampaign(item.campaign_status_type)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  const addCampaignToPositions = async () => {
    if (!positionsMustHaveThisCampaignButDoNotHave) {
      return;
    }

    if (positionsMustHaveThisCampaignButDoNotHave.length == 0) {
      return;
    }

    const campaignID = document.querySelector("#campaign-id").value;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    for (const key in positionsMustHaveThisCampaignButDoNotHave) {
      const positionsMustHaveThisCampaignButDoNotHaveItem =
        positionsMustHaveThisCampaignButDoNotHave[key];

      await sendRequestAddCampaignToPosition(
        positionsMustHaveThisCampaignButDoNotHaveItem.tag_html_id,
        {
          campaign_ID: campaignID + "",
          campaign_type_status:
            positionsMustHaveThisCampaignButDoNotHaveItem.campaign_status_type.replace(
              "campaign_IDS_",
              ""
            ),
        }
      );
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    setTimeout(() => {
      sendForm();
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    }, 3000);
  };

  const removeCampaignFromPositions = async () => {
    if (!positionsMustNotHaveThisCampaignButHave) {
      return;
    }

    if (positionsMustNotHaveThisCampaignButHave.length == 0) {
      return;
    }

    const campaignID = document.querySelector("#campaign-id").value;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    for (const key in positionsMustNotHaveThisCampaignButHave) {
      const positionsMustNotHaveThisCampaignButHaveItem =
        positionsMustNotHaveThisCampaignButHave[key];

      await sendRequestRemoveCampaignFromPositions(
        positionsMustNotHaveThisCampaignButHaveItem.tag_html_id,
        {
          campaign_ID: campaignID + "",
          campaign_type_status:
            positionsMustNotHaveThisCampaignButHaveItem.campaign_status_type.replace(
              "campaign_IDS_",
              ""
            ),
        }
      );
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    setTimeout(() => {
      sendForm();
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    }, 3000);
  };

  const sendRequestRemoveCampaignFromPositions = async (
    positionTagHtmlID,
    data
  ) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/position/manage/${positionTagHtmlID}/remove-campaign-manually`,
        data,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const sendRequestAddCampaignToPosition = async (positionTagHtmlID, data) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/position/manage/${positionTagHtmlID}/add-campaign-manually`,
        data,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  بررسی موجود بودن کمپین در جایگاه ها
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div>
                <div>
                  <p className="alert alert-info">
                    شماره کمپین بنری را از این
                    <Link
                      className="d-inline-block px-2"
                      to="/campaigns/manage/banner/simple/all"
                      target="_blank"
                    >
                      لیست
                    </Link>
                    و شماره کمپین بنری جایگزین را از این
                    <Link
                      className="d-inline-block px-2"
                      to="/campaigns/manage/banner-alternative/all"
                      target="_blank"
                    >
                      لیست
                    </Link>
                    پیدا کنید.
                  </p>
                </div>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    sendForm();
                  }}
                >
                  <div className="d-flex align-items-end">
                    <div className="flex-grow-1">
                      <label>شماره کمپین</label>
                      <input
                        className="form-control"
                        type="number"
                        id="campaign-id"
                      />
                    </div>
                    <div className="pr-2">
                      <button className="btn btn-primary">بررسی</button>
                    </div>
                  </div>
                </form>
              </div>
              <div>
                <div className="py-2">
                  <div className="d-flex align-items-end pb-2">
                    <span>
                      <p className="alert alert-warning m-0">
                        جایگاه های زیر که باید این کمپین را داشته باشن اما ندارن
                      </p>
                    </span>
                    <span
                      className="btn btn-primary mr-2"
                      onClick={() => {
                        addCampaignToPositions();
                      }}
                    >
                      اضافه کردن کمپین به جایگاه های زیر
                    </span>
                  </div>
                  {generateTablePositionsMustHaveThisCampaignButDoNotHave()}
                </div>
                <hr />
                <div className="py-2">
                  <div className="d-flex align-items-end pb-2">
                    <span>
                      <p className="alert alert-danger m-0">
                        جایگاه های زیر که نباید این کمپین را داشته باشن اما دارن
                      </p>
                    </span>
                    <span
                      className="btn btn-info mr-2"
                      onClick={() => {
                        removeCampaignFromPositions();
                      }}
                    >
                      حذف کردن کمپین از جایگاه های زیر
                    </span>
                  </div>
                  {generateTablePositionsMustNotHaveThisCampaignButHave()}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
export default CheckPositionCampaign;
